import(/* webpackMode: "eager", webpackExports: ["DirectPurchaseView"] */ "/app/src/ui/components/pages/direct-purchase-view/index.tsx");
